import { useContext } from "react";
import WindowBreakpointsContext from "../contexts/WindowBreakpointsContext";

const useWindowBreakpoints = () => useContext(WindowBreakpointsContext);

export default useWindowBreakpoints;
